import {FC, useCallback} from 'react';
import {useWatch} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';
import Button from 'components/Button';
import InputText from 'components/Form/InputText';
import {SearchRequest} from '../../services';

type SearchPanelProps = {
    hideSearchPanel: boolean;
    isLoading: boolean;
    onSearch: (request: SearchRequest) => void;
};

const SearchPanel: FC<SearchPanelProps> = ({
    hideSearchPanel,
    isLoading,
    onSearch,
}) => {
    const {t} = useTranslation('Staff.CustomTemplateSearch');

    const {keyword} = useWatch<{keyword: string}>();
    const onClick = useCallback(() => {
        if (keyword) onSearch({keyword, page: 1});
    }, [keyword, onSearch]);

    return (
        <div className={clsx('flex gap-x-2', hideSearchPanel && 'hidden')}>
            <InputText
                className="flex-1"
                classNameInput="w-full"
                label={t('fields.keyword')}
                name="keyword"
                placeholder={t('search')}
                required={true}
            />
            <Button
                className="mt-6"
                disabled={!keyword}
                icon="search"
                isLoading={isLoading}
                onClick={onClick}
                type="submit"
            >
                {t('search')}
            </Button>
        </div>
    );
};

export default SearchPanel;
